import moment from 'moment';

export const getActiveSubscriptions = (subscriptions) =>
  (subscriptions || []).filter((el) => el.status === 'ACTIVE');

export const getPaidSinglePayments = (singlePayments) =>
  (singlePayments || []).filter((el) => el.status === 'PAID');

export const getFormattedTransactionsData = (transactions) =>
  transactions.length
    ? transactions
        .map((el) => {
          const type =
            (el.userSinglePaymentId && 'userSinglePaymentId') ||
            (el.userSubscriptionId && 'userSubscriptionId');
          const orderNumber = el.userSinglePaymentId || el.userSubscriptionId;
          const nextBillingDate =
            el.nextBillingDate &&
            moment(el.nextBillingDate).format('DD.MM.YYYY');
          const expireDate =
            el.expireDate && moment(el.expireDate).format('DD.MM.YYYY');
          const { amount, createdDate } = el;
          const transaction = {
            type,
            orderNumber,
            amount: amount && amount / 100,
            createdDate:
              createdDate && moment(createdDate).format('DD.MM.YYYY'),
            nextBillingDate,
            expireDate,
            cancelled: nextBillingDate === expireDate,
          };
          return transaction;
        })
        .filter((el) => {
          if (el.expireDate) {
            if (new Date() > new Date(el.expireDate)) {
              return true;
            }
            return false;
          }
          return true;
        })
    : [];
